// src/Room/roomSlice.ts (eller där din slice bor)
import { IRootState } from "../app/store";
import { createAppSlice } from "../app/createAppSlice";
import { openapi } from "../../openapi";
import { thunkToast } from "../DesignTab/designSlice";
import { patchRoomFromQueryFulfilled } from "../McBim/McBimSlice";

export interface IRoomSliceState {
  test: string[];

  /** Valgt disiplin/responsibility for visning av specifiedArticles (fri streng) */
  selectedSpecifiedArticlesResponsibility: string; // "" = alle / ingen valgt
}

const initialState: IRoomSliceState = {
  test: [],
  selectedSpecifiedArticlesResponsibility: "",
};

export const roomSlice = createAppSlice({
  name: "room",
  initialState,
  reducers: (create) => ({
    setSelectedSpecifiedArticlesResponsibilityInRedux: create.reducer<string>((state, action) => {
      state.selectedSpecifiedArticlesResponsibility = action.payload;
    }),
  }),
});

export const {
  setSelectedSpecifiedArticlesResponsibilityInRedux,
} = roomSlice.actions;

// --- selectors ---------------------------------------------------------------

export const selectProjectNo = (state: IRootState) => state.design.projectNo;

export const selectSelectedSpecifiedArticlesResponsibility = (state: IRootState) =>
  state.room.selectedSpecifiedArticlesResponsibility;

// --- RTK Query enhance -------------------------------------------------------

const withGenericErrorToast =
  (inner?: (arg: any, helpers: { dispatch: any; queryFulfilled: Promise<any> }) => Promise<void>) =>
  async (arg: any, helpers: { dispatch: any; queryFulfilled: Promise<any> }) => {
    const { dispatch, queryFulfilled } = helpers;
    try {
      if (inner) {
        await inner(arg, helpers);
      } else {
        await queryFulfilled;
      }
    } catch {
      showGenericSaveErrorToast(dispatch);
    }
  };

const showGenericSaveErrorToast = (dispatch: any) => {
  dispatch(
    thunkToast({
      text: "Kunne ikke lagre data",
      header: "Misslykket",
      isSuccess: false,
    })
  );
};

export const enhancedApi = openapi.enhanceEndpoints({
  endpoints: {
    postMultiplacerRoomValidationDecisionStatus: {
      async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
        await patchRoomFromQueryFulfilled({ dispatch, getState, queryFulfilled });
      },
      invalidatesTags: ["SingleRoom"],
    },
    postMultiplacerRooms: {
      providesTags: ["Rooms"],
    },
    deleteMultiplacerRoomValidation: {
      invalidatesTags: ["Rooms"],
    },
    getMultiplacerSingleRoom: {
      providesTags: ["SingleRoom"],
    },
    postMultiplacerRoomValidationDecisionComment: {
      onQueryStarted: withGenericErrorToast(),
      invalidatesTags: ["SingleRoom"],
    },
    postMultiplacerRoomValidationDecisionCommentUpdate: {
      onQueryStarted: withGenericErrorToast(),
      invalidatesTags: ["SingleRoom"],
    },
    postMultiplacerRoomValidationDecisionCommentDelete: {
      onQueryStarted: withGenericErrorToast(),
      invalidatesTags: ["SingleRoom"],
    },
  },
});
